const FETCH_VARIANCE_STATUSES= "FETCH_VARIANCE_STATUSES";
const FETCH_VARIANCE_STATUSES_SUCCESS = "FETCH_VARIANCE_STATUSES_SUCCESS";
const FETCH_VARIANCE_STATUSES_ERROR = "FETCH_VARIANCE_STATUSES_ERROR";
const UPDATE_VARIANCE_STATUSES = "UPDATE_VARIANCE_STATUSES";
const UPDATE_VARIANCE_STATUSES_SUCCESS = "UPDATE_VARIANCE_STATUSES_SUCCESS";
const UPDATE_VARIANCE_STATUSES_ERROR = "UPDATE_VARIANCE_STATUSES_ERROR";
const DELETE_VARIANCE_STATUSES = "DELETE_VARIANCE_STATUSES";
const DELETE_VARIANCE_STATUSES_SUCCESS = "DELETE_VARIANCE_STATUSES_SUCCESS";
const DELETE_VARIANCE_STATUSES_ERROR = "DELETE_VARIANCE_STATUSES_ERROR";
const CREATE_VARIANCE_STATUSES = "CREATE_VARIANCE_STATUSES";
const CREATE_VARIANCE_STATUSES_SUCCESS = "CREATE_VARIANCE_STATUSES_SUCCESS";
const CREATE_VARIANCE_STATUSES_ERROR = "CREATE_VARIANCE_STATUSES_ERROR";
const IS_ADDING_UPDATE = "IS_ADDING_UPDATE";
const UPDATE_ORDER = "UPDATE_ORDER";
const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS";
const UPDATE_ORDER_ERROR = "UPDATE_ORDER_ERROR";
const SET_COMPLETED_STATUS = "SET_COMPLETED_STATUS";

export {
  FETCH_VARIANCE_STATUSES,
  FETCH_VARIANCE_STATUSES_SUCCESS,
  FETCH_VARIANCE_STATUSES_ERROR,
  UPDATE_VARIANCE_STATUSES,
  UPDATE_VARIANCE_STATUSES_SUCCESS,
  UPDATE_VARIANCE_STATUSES_ERROR,
  DELETE_VARIANCE_STATUSES,
  DELETE_VARIANCE_STATUSES_SUCCESS,
  DELETE_VARIANCE_STATUSES_ERROR,
  CREATE_VARIANCE_STATUSES,
  CREATE_VARIANCE_STATUSES_SUCCESS,
  CREATE_VARIANCE_STATUSES_ERROR,
  UPDATE_ORDER,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_ERROR,
  IS_ADDING_UPDATE,
  SET_COMPLETED_STATUS,
};
